var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRejected)?_c('tr',[_c('td'),_vm._m(0),_c('td',{staticClass:"px-2",attrs:{"colspan":"5"}},[_vm._v("\n    "+_vm._s(_vm.rejectReason)+"\n  ")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"no-wrap px-2"},[_c('span',{staticStyle:{"color":"gray"}},[_vm._v("却下理由")])])
}]

export { render, staticRenderFns }